export default {
  SET_USER: 'SET_USER',
  SET_PERMISSIONS: 'SET_PERMISSIONS',
  SET_USER_LOGOUT: 'SET_USER_LOGOUT',
};
